const getters = {
    teamStatus: state => state.teamStatus,
    teamErrors: state => state.teamErrors,
    teams: state => state.teams,
    teamsCount: state => state.teamsCount,
    teamDetailById: (state) => (id) => {
        return state.teams.find(team => team.t_id === id)
    },
}

export default getters
